import { Controller } from '../utils/controller';

export default class extends Controller {
  readonly DELIVERY_PATH: string = '/checkout#/delivery';

  static targets = ['backButton', 'returnToCartLink'];
  static requiredTargets = [];
  // TARGETS
  declare backButtonTarget: HTMLImageElement;
  declare returnToCartLinkTarget: HTMLImageElement;

  connect(): void {
    const path = this.derivePath(window.location.href);
    this.onHashChange(path);

    window.addEventListener('hashchange', (event: HashChangeEvent) => {
      const path = this.derivePath(event.newURL);
      this.onHashChange(path);
    });
  }

  derivePath(url: string): string {
    const urlObj = new URL(url);
    return urlObj.pathname.concat(urlObj.hash);
  }

  onHashChange(urlPath: string): void {
    if (this.matchesDeliveryPath(urlPath)) {
      this.backButtonTarget.classList.add('hidden');
      this.returnToCartLinkTarget.classList.remove('hidden');
    } else {
      this.backButtonTarget.classList.remove('hidden');
      this.returnToCartLinkTarget.classList.add('hidden');
    }
  }

  private matchesDeliveryPath(urlPath: string): boolean {
    const regex = new RegExp(this.DELIVERY_PATH, 'i');
    return urlPath.match(regex) ? true : false;
  }
}
